"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var ReleaseState_1 = require("../../release/model/ReleaseState");

var SelloutIdentificationDetailDTO_1 = require("../model/sellout-identification/SelloutIdentificationDetailDTO");

var SelloutIdentificationDetailDTOConverter_1 = require("./SelloutIdentificationDetailDTOConverter");
/**
 * @author Adam Drda
 */


var SelloutIdentificationDetailDTOConverterImpl =
/*#__PURE__*/
function (_SelloutIdentificatio) {
  _inherits(SelloutIdentificationDetailDTOConverterImpl, _SelloutIdentificatio);

  function SelloutIdentificationDetailDTOConverterImpl() {
    _classCallCheck(this, SelloutIdentificationDetailDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutIdentificationDetailDTOConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutIdentificationDetailDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc`
     */
    value: function toObject(source, conversions) {
      return new SelloutIdentificationDetailDTO_1.SelloutIdentificationDetailDTO(SelloutIdentificationDetailDTO_1.SelloutIdentificationDetailDTO.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), SelloutIdentificationDetailDTO_1.SelloutIdentificationDetailDTO.schema.productName.valueOfField(source), conversions.asObjectOpt(source, 'productExternalId', function (v) {
        return utils_1.Utils.getCustomerId(v);
      }), SelloutIdentificationDetailDTO_1.SelloutIdentificationDetailDTO.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), SelloutIdentificationDetailDTO_1.SelloutIdentificationDetailDTO.schema.siteName.valueOfField(source), conversions.asObjectOpt(source, 'releaseName', function (v) {
        return v;
      }), conversions.asEnumOpt(source.releaseState, ReleaseState_1.ReleaseState), SelloutIdentificationDetailDTO_1.SelloutIdentificationDetailDTO.schema.selloutType.valueOfField(source), conversions.asObjectOpt(source, 'selloutVolume', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'selloutPrice', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'stockValue', function (v) {
        return conversions.toBigNumber(v);
      }), SelloutIdentificationDetailDTO_1.SelloutIdentificationDetailDTO.schema.daysLeft.valueOfField(source), SelloutIdentificationDetailDTO_1.SelloutIdentificationDetailDTO.schema.endDate.valueOfField(source), conversions.asObjectOpt(source, 'estimationInPercent', function (v) {
        return conversions.toBigNumber(v);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        productName: source.productName,
        productExternalId: source.productExternalId,
        siteId: conversions.toDocumentReferenceId(source.siteId),
        siteName: source.siteName,
        releaseName: source.releaseName,
        releaseState: source.releaseState,
        selloutType: source.selloutType,
        selloutVolume: source.selloutVolume ? conversions.fromBigNumber(source.selloutVolume) : null,
        selloutPrice: source.selloutPrice ? conversions.fromBigNumber(source.selloutPrice) : null,
        stockValue: source.stockValue ? conversions.fromBigNumber(source.stockValue) : null,
        daysLeft: source.daysLeft,
        endDate: source.endDate ? conversions.fromDate(source.endDate) : null,
        estimationInPercent: source.estimationInPercent ? conversions.fromBigNumber(source.estimationInPercent) : null
      });
      return result;
    }
  }]);

  return SelloutIdentificationDetailDTOConverterImpl;
}(SelloutIdentificationDetailDTOConverter_1.SelloutIdentificationDetailDTOConverter);

exports.SelloutIdentificationDetailDTOConverterImpl = SelloutIdentificationDetailDTOConverterImpl;